module.exports = __webpack_public_path__ + "static/media/ring-line-1.9a41d960.svg";